import React from 'react';
import './style.scss';

interface ModalProps {
    handleLeftClick?: () => void;
    handleRightClick?: () => void;
    leftButtonText?: string;
    rightButtonText: string;
    title?: string;
    content: string;
    icon: string;
    target?: string;
}

const Modal = ({ handleLeftClick, handleRightClick, leftButtonText, rightButtonText, title, content, icon, target }: ModalProps) => {
    return (
        <div
            aria-hidden="true"
            aria-labelledby="modalLabel"
            className="modal fade modal-alert"
            data-backdrop="static"
            data-keyboard="false"
            id={target || 'alert-modal'}
            role="dialog"
            tabIndex={-1}
        >
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="alert-modal-content modal-content">
                    <div className="modal-inner">
                        <i className="material-icons-outlined align-middle">{icon}</i>
                        <div className="inner-content">
                            {title && <span className="text-title">{title}</span>}
                            <span className="text-content">{content}</span>
                        </div>
                    </div>
                    <div className="modal-bottom">
                        {leftButtonText && (
                            <button className="btn btn-secondary left-button" data-dismiss="modal" onClick={handleLeftClick} type="button">
                                {leftButtonText}
                            </button>
                        )}
                        <button className="btn btn-primary right-button" data-dismiss="modal" onClick={handleRightClick} type="button">
                            {rightButtonText}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Modal;
